import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NbDialogRef, NbDialogService, NbToastrService } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { PAYLOAD_TYPES } from 'src/app/shared/constants/general-constants';
import { TimestampDatePipe } from 'src/app/shared/pipes/timestamp-date.pipe';
import { PreviewContentComponent } from 'src/app/shared/ui/preview-content/preview-content.component';
import { DrbIdsAndValuesState } from '../../../drbs/redux';
import { DrbService } from '../../../drbs/services/drb.service';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-view-content',
  templateUrl: './view-content.component.html',
  styleUrls: ['./view-content.component.css'],
  standalone: true,
  imports: [SharedModule],
  providers: [TimestampDatePipe]
})
export class ViewContentComponent implements OnInit, OnDestroy {
  public drbIdAndValue$: Observable<any> = inject(Store).select(DrbIdsAndValuesState.allDrbIdsAndValues);
  private unsubscribe: Subject<void> = new Subject();

  public content;

  public localeDisplays: string[] = [];

  public formatted_created_time = '';
  public formatted_updated_date = '';

  public drbIdsAndValues;
  public showSpinner = false;

  constructor(
    protected ref: NbDialogRef<ViewContentComponent>,
    private formatDatePipe: TimestampDatePipe,
    private dialogService: NbDialogService,
    private drbService: DrbService,
    private toastrService: NbToastrService
  ) {}

  public ngOnInit() {
    this.drbIdAndValue$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.drbIdsAndValues = data));
    this.handleDate();
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public formatDate = (time) => {
    const formatted_time = this.formatDatePipe.transform(time, 'timestampToDate');
    if (formatted_time) {
      return formatted_time;
    } else {
      return '';
    }
  };

  public handleDate() {
    const created_date = this.content.created_dttm;
    this.formatted_created_time = this.formatDate(created_date);

    const updated_date = this.content.last_updated_dttm;
    this.formatted_updated_date = this.formatDate(updated_date);
  }

  public close() {
    this.ref.close();
  }

  public async previewContent() {
    const drbIds = PreviewContentComponent.getDrbIds(this.content);
    if (drbIds.length === 0) {
      this.dialogService.open(PreviewContentComponent, {
        closeOnEsc: true,
        closeOnBackdropClick: true,
        context: {
          content: this.content,
          values: [],
          isPersonalizedOffer: this.content.payload_records[0]?.payload_record_type === PAYLOAD_TYPES.PERSONALIZED_OFFER
        }
      });
    } else {
      this.showSpinner = true;
      const data = await this.drbService.loadDrbValues(drbIds);
      this.showSpinner = false;
      if (data != null) {
        this.toastrService.show(status, $localize`Fetching drb values Complete: `, { status: 'success' });
        this.dialogService.open(PreviewContentComponent, {
          closeOnEsc: true,
          closeOnBackdropClick: true,
          context: {
            content: this.content,
            values: data,
            isPersonalizedOffer:
              this.content.payload_records[0]?.payload_record_type === PAYLOAD_TYPES.PERSONALIZED_OFFER
          }
        });
      }
    }
  }
}
